import actionTypes from './actionTypes';
const INITIAL_STATE = {
  introducedCafesLoading: false,
  introducedCafesFailed: false,
  introducedCafesError: false,
  introducedCafesMessage: null,
  introducedCafesList: [],
  introducedCafes: {},

  introducedCafeDetailsLoading: false,
  introducedCafeDetailsFailed: false,
  introducedCafeDetailsError: false,
  introducedCafeDetailsMessage: false,
  introducedCafeDetails: {},

  changeIntroducedCafeStatusLoading: false,
  changeIntroducedCafeStatusFailed: false,
  changeIntroducedCafeStatusError: false,
  changeIntroducedCafeStatusMessage: null,
  changeIntroducedCafeStatusResponse: {}
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_INTRODUCED_CAFES_LOADING: {
      return {
        ...state,
        introducedCafesLoading: true,
        introducedCafesFailed: false,
        introducedCafesError: false,
        introducedCafesMessage: null,
        introducedCafesList: [],
        introducedCafes: {}
      };
    };
    case actionTypes.FETCH_INTRODUCED_CAFES_SUCCESS: {
      return {
        ...state,
        introducedCafesLoading: false,
        introducedCafesFailed: false,
        introducedCafesError: false,
        introducedCafesMessage: null,
        introducedCafesList: [...action.payload.introducedCafes],
        introducedCafes: { ...action.payload }
      };
    };
    case actionTypes.FETCH_INTRODUCED_CAFES_INTRODUCED_CAFES_FAILED: {
      const { message } = action.payload
      return {
        ...state,
        introducedCafesLoading: false,
        introducedCafesFailed: true,
        introducedCafesError: false,
        introducedCafesMessage: message,
        introducedCafesList: [],
        introducedCafes: {}
      }
    }
    case actionTypes.FETCH_INTRODUCED_CAFES_REJECT: {
      return {
        ...state,
        introducedCafesLoading: false,
        introducedCafesFailed: false,
        introducedCafesError: true,
        introducedCafesMessage: null,
        introducedCafesList: [],
        introducedCafes: {}
      }
    }


    case actionTypes.FETCH_INTRODUCED_CAFE_DETAILS_LOADING: {
      return {
        ...state,
        introducedCafeDetailsLoading: true,
        introducedCafeDetailsFailed: false,
        introducedCafeDetailsError: false,
        introducedCafeDetailsMessage: null,
        introducedCafeDetails: {}
      };
    };
    case actionTypes.FETCH_INTRODUCED_CAFE_DETAILS_SUCCESS: {
      return {
        ...state,
        introducedCafeDetailsLoading: false,
        introducedCafeDetailsFailed: false,
        introducedCafeDetailsError: false,
        introducedCafeDetailsMessage: null,
        introducedCafeDetails: { ...action.payload }
      };
    };
    case actionTypes.FETCH_INTRODUCED_CAFES_INTRODUCED_CAFE_DETAILS_FAILED: {
      const { message } = action.payload
      return {
        ...state,
        introducedCafeDetailsLoading: false,
        introducedCafeDetailsFailed: true,
        introducedCafeDetailsError: false,
        introducedCafeDetailsMessage: message,
        introducedCafeDetails: {}
      }
    }
    case actionTypes.FETCH_INTRODUCED_CAFE_DETAILS_REJECT: {
      return {
        ...state,
        introducedCafeDetailsLoading: false,
        introducedCafeDetailsFailed: false,
        introducedCafeDetailsError: true,
        introducedCafeDetailsMessage: null,
        introducedCafeDetails: {}
      }
    }


    case actionTypes.CHANGE_INTRODUCED_CAFE_STATUS_LOADING: {
      return {
        ...state,
        changeIntroducedCafeStatusLoading: true,
        changeIntroducedCafeStatusFailed: false,
        changeIntroducedCafeStatusError: false,
        changeIntroducedCafeStatusMessage: null,
        changeIntroducedCafeStatusResponse: {}
      };
    };
    case actionTypes.CHANGE_INTRODUCED_CAFE_STATUS_SUCCESS: {
      return {
        ...state,
        changeIntroducedCafeStatusLoading: false,
        changeIntroducedCafeStatusFailed: false,
        changeIntroducedCafeStatusError: false,
        changeIntroducedCafeStatusMessage: null,
        changeIntroducedCafeStatusResponse: { ...action.payload }
      };
    };
    case actionTypes.CHANGE_INTRODUCED_CAFE_STATUS_FAILED: {
      const { message } = action.payload
      return {
        ...state,
        changeIntroducedCafeStatusLoading: false,
        changeIntroducedCafeStatusFailed: true,
        changeIntroducedCafeStatusError: false,
        changeIntroducedCafeStatusMessage: message,
        changeIntroducedCafeStatusResponse: {}
      }
    }
    case actionTypes.CHANGE_INTRODUCED_CAFE_STATUS_REJECT: {
      return {
        ...state,
        changeIntroducedCafeStatusLoading: false,
        changeIntroducedCafeStatusFailed: false,
        changeIntroducedCafeStatusError: true,
        changeIntroducedCafeStatusMessage: null,
        changeIntroducedCafeStatusResponse: {}
      }
    }
    default:
      return state;
  }
};